
import HttpRequest from '@/libs/axios'
import weconfig from '@/libs/config'
const axios = new HttpRequest(weconfig.requireUrl)
export default axios
